import Select from 'react-select'
import restClient from "Shared/hooks/restClient"
import './RoleSwitcher.scoped.scss'
import { current } from '@reduxjs/toolkit'

export default function RoleSwitcher() {
  const [userRoles, setUserRoles] = useState([])
  const [currentUserRoleId, setCurrentUserRoleId] = useState(null)

  useEffect(() => {
    restClient.get('/api/me/user_roles')
      .then(({ data }) => {
        setUserRoles(data.userRoles)
        setCurrentUserRoleId(data.currentUserRoleId)
      })
      .catch((e) => { console.error(e) })
  }, [])

  const options = userRoles.map(userRole => ({
    value: userRole.id,
    label: `${userRole.organisationName} - ${userRole.roleName} ${userRole.id === currentUserRoleId ? '(current)' : ''}`
  }))
  const currentOption = options.find(option => option.value === currentUserRoleId)
  console.log('currentOption', currentOption)

  const handleRoleChange = (selectedOption) => {
    const payload = { userRoleId: selectedOption.value }
    restClient.post('/api/me/change_active_role', payload)
    .then(() => window.location.href = '/admin')
  }

  return (
    <div id="admin-user-tools">
      <div className="field" id="switchRole">
        <Select
          id="client-select"
          className="basic-single"
          menuPortalTarget={document.body}
          styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
          menuShouldScrollIntoView={true}
          defaultValue={currentOption}
          value={currentOption}
          options={options}
          onChange={handleRoleChange}
        />
      </div>
    </div>
  )
}
